var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.432 25.555"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2,
    "data-name": "Group 574"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.419 23.298a.37.37 0 0 0 .292.149.37.37 0 0 0 .29-.141c.305-.39 7.475-9.6 7.475-15.441a7.766 7.766 0 0 0-15.531 0c0 2.235 1.261 5.517 3.749 9.755a73 73 0 0 0 3.725 5.678Zm.3-22.46a7.035 7.035 0 0 1 7.027 7.028c0 4.928-5.646 12.761-7.02 14.594-1.357-1.9-7.035-10.126-7.035-14.594A7.035 7.035 0 0 1 8.715.838Z",
    "data-name": "Path 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.18 7.865a4.464 4.464 0 1 0-4.464 4.464 4.464 4.464 0 0 0 4.464-4.464Zm-4.464 3.726a3.726 3.726 0 1 1 3.726-3.726 3.726 3.726 0 0 1-3.726 3.726Z",
    "data-name": "Path 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.478 20.932a.37.37 0 0 0-.09.733c3.177.39 4.205 1.125 4.205 1.42 0 .554-2.78 1.632-7.878 1.632S.837 23.638.837 23.085c0-.316 1.008-.963 3.714-1.355a.37.37 0 0 0-.105-.731C2.464 21.286.1 21.88.1 23.084c0 1.739 5.152 2.37 8.616 2.37s8.616-.631 8.616-2.37c-.001-1.354-3.041-1.929-4.854-2.152Z",
    "data-name": "Path 34"
  }))));
};
export default SvgLocation;